'use client'

import { PropsWithChildren } from 'react';

interface CardBoxCheckoutProps {
  icon?: any;
  iconTop?: boolean;
  className?: string;
}

const CardBoxCheckout = ({icon, iconTop=true, className, children}: PropsWithChildren<CardBoxCheckoutProps>) => {
  return (
    <div className={`flex gap-2 w-full justify-between items-center rounded-lg p-2 px-3 bg-gray-50 shadow shadow-gray-200/60 ${className}`}>
      { icon && <div className={`text-lg ${iconTop && 'self-start'}`}>{ icon }</div> }
      <div className="flex flex-col w-full">
        { children }
      </div>
  </div>
  )
}

export default CardBoxCheckout;